import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css, injectGlobal } from 'styled-components';
import { rgba } from 'polished';

import { media } from '../../styles/utils';
import { green, greenSecondary } from '../../styles/colors';
import { hoverState, padding } from '../../styles/global';

class Attachment extends Component {

    static defaultProps = {
        url: 'https://storedesign.aesop.com/api/wp-content/uploads/2017/10/Design-Principles_170607SECURED.pdf',
        label: 'Attachment Name',
        size: '2mb'
    }

    state = {
        
    }

    resolveFiletype = (file) => {
        if (file.filename) {
            const type = file.filename.split('.').pop();
            return type
        }
    }

    render() {
        const { label, size, url, file } = this.props;

        return (
            <Container
                href={url}  
                {...this.props}
                target={'_blank'}
            >
                <Placeholder>
                    <Type>
                        {this.resolveFiletype(file)}
                    </Type>
                </Placeholder>
                <Label>{label}</Label>
                <Size>{size}</Size>
            </Container>
        )
    }
}

const Container = styled.a`
    display: flex;
    flex-direction: column;   
    font-size: 16px;
    ${hoverState}

    ${props => {
        if (props.border == 'black') return css`
            ${Placeholder} {
                border-color: black;
            } 
        `
    }}

    ${media.phone`
        flex-direction: row;
    `}
`

const Placeholder = styled.div`
    height: 126px;
    width: 88px;
    border: 1px solid #979797;
    margin-bottom: 14px;
    position: relative;

    ${media.phone`
        height: 20px;
        width: auto;
        margin-right: 8px;
        margin-bottom: 0;
    `}
`

const Type = styled.div`
    text-transform: uppercase;
    position: absolute;
    top: 0px;
    left: 2px;
    font-size: 16px;
    padding-right: 4px;

    ${media.phone`
        position: inherit;
    `}
`

const Label = styled.div`
    ${media.phone`
        width: 60vw;
        margin-right: auto;
    `}
`

const Size = styled.div`

` 

export default Attachment;


// WEBPACK FOOTER //
// ./client/components/Attachment/Attachment.js